'use client'
import React, { FC } from 'react'
import { throttle, toString } from 'lodash'
import { CardActions, CardActionsProps } from '@docpace/shared-react-components/Card'
import { Button } from '@docpace/shared-react-components/Button'

interface FormSubmitControlsProps {
    // variant?: ButtonProps['variant']
    onCancel?: () => void
    onReset?: () => void
    onSubmit?: () => void
    submitError?: Error
    disableSubmitType?: boolean
    submitTitle?: string
}

export const FormSubmitControls: FC<FormSubmitControlsProps> = (
    props
) => {
    const {
        onCancel,
        onReset,
        onSubmit,
        submitError,
        disableSubmitType,
        submitTitle = 'Save',
        ...cardActionsProps
    } = props
    const onSubmitThrottled = onSubmit && throttle(onSubmit, 250)// if changed, also update useMuiLoadingIndicator to match
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                justifyContent: 'flex-end',
            }}
        >
            {submitError ? (
                <div className='text-red-500 h-4'>
                    { toString(submitError?.message)}
                </div>
            ) : (
                <></>
            )}
            <div
                className={'mt-2 flex justify-end items-center space-x-1'}
                {...cardActionsProps}
                // style={{ display: 'flex', justifyContent: 'flex-end' }}
            >
                {onCancel && (
                    <div
                        className='btn btn-sm btn-ghost'
                        onClick={() => onCancel()}
                    >
                        Cancel
                    </div>
                )}
                {onReset && (
                    <button
                        onClick={() => onReset()}
                        className='btn btn-sm bg-yellow-400'
                    >
                        Reset
                    </button>
                )}
                {(onSubmit || !disableSubmitType) && (
                    <button
                        onClick={onSubmitThrottled}
                        type={!disableSubmitType ? 'submit' : null}
                        className='btn btn-sm bg-teal-600 hover:bg-teal-700 dark:bg-docpace-dark text-white dark:text-white'
                    >
                        {submitTitle}
                    </button>
                )}
            </div>
        </div>
    )
}

export default FormSubmitControls
